const internshipsData = [
  {
    title: "Office Intern at Bestman Exceed Software LLP",
    company: "Bestman Exceed Software LLP",
    location:
      "FD-84, Sector-III, Salt Lake City Kolkata-700 106, West Bengal, India",
    role: "Website design, Sales and marketing, Technical support",
    duration: "November, 2023 - January, 2024",
  },
];

export default internshipsData;
